// Needed to support async await
import 'regenerator-runtime/runtime'
import render from 'commons/js/util/render'
import App from './App'

const element = document.getElementById('fine-portal')
const town = parseInt(element.dataset.townid)
const theme = element.dataset.theme
const brandImage = element.dataset.brandimage
const brandImageMobile = element.dataset.brandimagemobile
const brandId = parseInt(element.dataset.brand)
const bulletinNumber = parseInt(element.dataset.bulletinnumber)
const props = {town, theme, brandImage, brandImageMobile, brandId, bulletinNumber}

render({ App, element, props })

if (module.hot) {
    module.hot.accept('./App', () => {
        render({ App, element, props })
    })
}
